/* ==========================================================
   CELLFY PDP — FAQ Accordion
   ========================================================== */
(function () {
  'use strict';

  function init() {
    var toggles = document.querySelectorAll('[data-cellfy-faq-toggle]');
    if (!toggles.length) return;

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var item = toggle.closest('[data-cellfy-faq-item]');
        if (!item) return;

        var answer = item.querySelector('[data-cellfy-faq-answer]');
        if (!answer) return;

        var isOpen = toggle.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          // Fechar
          toggle.setAttribute('aria-expanded', 'false');
          answer.style.maxHeight = '0';
        } else {
          // Abrir — calcula altura real do conteúdo
          toggle.setAttribute('aria-expanded', 'true');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });

    // Recalcula altura ao redimensionar (caso texto quebre em mais linhas)
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        document.querySelectorAll('[data-cellfy-faq-toggle][aria-expanded="true"]').forEach(function (toggle) {
          var item = toggle.closest('[data-cellfy-faq-item]');
          var answer = item && item.querySelector('[data-cellfy-faq-answer]');
          if (answer) {
            answer.style.maxHeight = answer.scrollHeight + 'px';
          }
        });
      }, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();